import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Language, Role } from "../../../../../../../../../../services";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";
import { getRoleDisplayName } from "../../../../../../../../../../assets/languages/langs";

const NameCellContent: React.FC<NameCellContent.Props> = ({ item }) => {
	const { i18n } = useTranslation();
	const content = useMemo(
		() => getRoleDisplayName(item.name, i18n.language as Language),
		[item.name, i18n.language],
	);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace NameCellContent {
	interface Props {
		item: Role.Model;
	}
}

export default NameCellContent;
